/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class ProcessInstanceVariablesApi extends BaseApi {
    createOrUpdateProcessInstanceVariables(processInstanceId, restVariables) {
        throwIfNotDefined(processInstanceId, 'processInstanceId');
        throwIfNotDefined(restVariables, 'restVariables');
        const pathParams = {
            processInstanceId
        };
        return this.put({
            path: '/api/enterprise/process-instances/{processInstanceId}/variables',
            pathParams,
            bodyParam: restVariables
        });
    }
    deleteProcessInstanceVariable(processInstanceId, variableName) {
        throwIfNotDefined(processInstanceId, 'processInstanceId');
        throwIfNotDefined(variableName, 'variableName');
        const pathParams = {
            processInstanceId,
            variableName
        };
        return this.delete({
            path: '/api/enterprise/process-instances/{processInstanceId}/variables/{variableName}',
            pathParams
        });
    }
    getProcessInstanceVariable(processInstanceId, variableName) {
        throwIfNotDefined(processInstanceId, 'processInstanceId');
        throwIfNotDefined(variableName, 'variableName');
        const pathParams = {
            processInstanceId,
            variableName
        };
        return this.get({
            path: '/api/enterprise/process-instances/{processInstanceId}/variables/{variableName}',
            pathParams
        });
    }
    getProcessInstanceVariables(processInstanceId) {
        throwIfNotDefined(processInstanceId, 'processInstanceId');
        const pathParams = {
            processInstanceId
        };
        return this.get({
            path: '/api/enterprise/process-instances/{processInstanceId}/variables',
            pathParams
        });
    }
    updateProcessInstanceVariable(processInstanceId, variableName, restVariable) {
        throwIfNotDefined(processInstanceId, 'processInstanceId');
        throwIfNotDefined(variableName, 'variableName');
        throwIfNotDefined(restVariable, 'restVariable');
        const pathParams = {
            processInstanceId,
            variableName
        };
        return this.put({
            path: '/api/enterprise/process-instances/{processInstanceId}/variables/{variableName}',
            pathParams,
            bodyParam: restVariable
        });
    }
}
